import React from "react";
import { IUserInfo } from "../../../entities/common";
import { ApprovalDecisionInfo } from "../../../store/TimeTrackingStore";
import { ApprovalDecisionType } from "../../../store/ApprovalCenterStore";
import { renderTooltipField } from "./cell/TimeTrackingCellTooltip";
import { FormatDate } from "../../utils/common";
import ResourceFormatter from "../../common/formatters/ResourceFormatter";

type Props = {
    approvers: IUserInfo[] | null;
    decision: ApprovalDecisionInfo | null;
};

const ApprovalStatusTooltipContent = (props: Props) => {
    const { decision } = props;
    const approvers = decision?.approver
        ? [decision.approver]
        : (props.approvers ?? []);

    return (
        <>
            {renderTooltipField("Approver", approvers.length > 0 ? <ResourceFormatter resource={approvers} /> : "-")}
            {renderTooltipField("Decision", decision ? decisionLabel(decision.decision) : "-")}
            {renderTooltipField("Decision Date", decision ? (FormatDate(decision.decisionDate) ?? "-") : "-")}
            {renderTooltipField("Comment", decision?.comment ?? "-")}
        </>
    );
};

const decisionLabel = (decision: ApprovalDecisionType): string => {
    switch (decision) {
        case ApprovalDecisionType.Approved:
            return "Approved";
        case ApprovalDecisionType.Rejected:
            return "Rejected";
        default:
            return "";
    }
};

export default ApprovalStatusTooltipContent;
